import { createMuiTheme } from "@material-ui/core";

export default createMuiTheme({
    palette: {
        primary: {
            main: '#f04b4c'
        },
        secondary: {
            main: '#424242'
        },
    }
});